import Altadena101 from "./tipe10 (1).png";
import Altadena102 from "./tipe10 (2).png";
import Altadena103 from "./tipe10 (3).png";

const altadena10 = [Altadena101, Altadena102, Altadena103];

export default altadena10;
